import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import OnboardingDialog from "@/components/dialogs/OnboardingDialog";

export default function ProtectedRoute({ children }) {
  const { user, loading, checkAuth } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen bg-[var(--bg-deep)] text-[var(--text-primary)] flex items-center justify-center"
        data-testid="auth-loading"
      >
        <div className="flex items-center gap-3 text-[var(--text-muted)] text-sm">
          <span className="inline-block w-2 h-2 bg-[#E82127] rounded-full animate-pulse" />
          Loading…
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const needsOnboarding = user.onboarded === false;
  return (
    <>
      {children}
      <OnboardingDialog
        open={needsOnboarding}
        userName={user.name}
        onDone={async () => {
          await checkAuth();
          // Force a soft refresh of the active page so it picks up new data
          window.location.reload();
        }}
      />
    </>
  );
}
